<script lang="ts" setup>
import BreadCrumb from "@/components/BreadCrumb.vue";
import LoadingModal from "@/components/LoadingModal.vue";
import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import useBrand from "./composables/useBrand";
import InformationGeneral from "./partials/InformationGeneral.vue";
import ListOfChain from "./partials/ListOfChain.vue";

const route = useRoute();

const { hasPermissionUser } = useHasPermissionUser();

const { data, isLoading } = useBrand({
  immediate: true,
  params: {
    id: route.params.id as string,
  },
});

const tabs = ref([
  {
    name: "Informacion General",
    component: InformationGeneral,
    permissionName: ["update-internal", "create-medias-internal"],
    module: ["App\\Models\\Brand", "App\\Models\\Brand"],
  },
  {
    name: "Listado de hoteles",
    component: ListOfChain,
    permissionName: ["viewAny-internal"],
    module: ["App\\Models\\Brand"],
  },
]);

const pages = ref([
  {
    name: "Proveedores de hoteleria",
    to: {
      name: "hotel",
    },
  },
  {
    name: "Marcas",
    to: {
      name: "hotel.brands",
    },
  },
  {
    name: "Editar",
    to: {
      name: "hotel.brands.edit",
      params: {
        id: route.params.id,
      },
    },
  },
]);

watch(
  data,
  (value) => {
    if (value) {
      pages.value[2].name = `Editar ${value.name}`;
    }
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <BreadCrumb :pages="pages" />

  <TabGroup
    :default-index="
      route.query.tab
        ? tabs.findIndex((tab) => tab.name === route.query.tab)
        : 0
    "
    as="div"
    class="flex flex-col lg:flex-row gap-6 max-w-7xl mx-auto px-4 lg:px-[2.75rem] py-2 mb-7"
    v-if="!isLoading"
  >
    <TabList
      as="aside"
      class="flex flex-col gap-4 lg:w-1/3 lg:max-w-[13.75rem] !lg:sticky mt-8"
    >
      <nav
        v-dragscroll.x
        class="no-scrollbar flex touch-pan-x px-2 lg:p-0 w-full lg:max-w-[13.75rem] flex-row lg:flex-col gap-2 overflow-x-auto"
      >
        <Tab
          v-for="tab in tabs.filter((tab) => {
            return tab.permissionName.some((permission, i) =>
              hasPermissionUser(permission, tab.module[i]),
            );
          })"
          :key="tab.name"
          v-slot="{ selected }"
          class="rounded-md w-[13.75rem]"
        >
          <button
            :class="[
              'w-full py-3 px-2 font-medium whitespace-nowrap rounded-md text-white focus:outline-none select-none',
              selected ? 'bg-[#253C70]' : 'bg-[#1F2937]',
            ]"
          >
            {{ tab.name }}
          </button>
        </Tab>
      </nav>
    </TabList>

    <TabPanels as="div" class="w-full">
      <TabPanel
        v-for="Element in tabs.filter((tab) => {
          return tab.permissionName.some((permission, i) =>
            hasPermissionUser(permission, tab.module[i]),
          );
        })"
        :key="Element.name"
      >
        <component :is="Element.component" :brand="data!" />
      </TabPanel>
    </TabPanels>
  </TabGroup>

  <LoadingModal :when="isLoading" />
</template>
